const ALLOW_ORIGIN = '*';

// 460px is SIDE_PANEL_WIDTH from automation-ui-core
export const SIDE_PANEL_WIDTH = '460px';

/* eslint-disable no-bitwise */
export const UUID = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
};
/* eslint-enable no-bitwise */

export const sendMessageToParent = message => {
  window.parent.postMessage(message, ALLOW_ORIGIN);
};

// TODO (JB): Define an interface we use for data based off of data we send

export const sendMessageToChild = (childElem, data) => {
  if (!childElem || !childElem.contentWindow) return;
  childElem.contentWindow.postMessage(data, ALLOW_ORIGIN);
};
export const getSidePanelWidth = (fullScreen, width = SIDE_PANEL_WIDTH) => {
  if (fullScreen) {
    return '100vw';
  }

  // extra 6px's is to give space for box shadow
  return `calc(${width} + 6px)`;
};
export const noop = () => ({});